import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ff3ed0c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "top-container searchTop"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  key: 0,
  class: "button-container"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
const _hoisted_6 = {
  class: "dialog-foter"
};
import { listPermission, deletePermission, batchDeletePermission, addPermission, updatePermission, listTenantOptions, listAdminOptions } from "@/api/system1/tenant";
import { getPublicKey } from "@/api/system1/user";
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus';
import { getCurrentInstance } from "vue";
import { weChatrequest } from '@/utils/request';
import JSEncrypt from 'jsencrypt';
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const form = ref(null);
    const form1 = ref(null);
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "正常"
    }, {
      dictValue: 0,
      dictLabel: "停用"
    }]);
    const statusOptions1 = ref([]);
    const statusOptions2 = ref([]);
    const statusOptions3 = ref([{
      dictValue: 1,
      dictLabel: "是"
    }, {
      dictValue: 0,
      dictLabel: "否"
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 租户表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        tenantId: null,
        tenantCode: "",
        username: ''
      },
      form1: {
        password: '',
        id: ''
      },
      // 表单参数
      form: {
        adminUserId: "",
        tenantId: [],
        remark: ""
      },
      rules1: {
        password: [{
          required: true,
          message: "新密码不能为空",
          trigger: "blur"
        }, {
          pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
          message: "密码必须包含字母、数字和英文特殊字符，长度为最少8位",
          trigger: "blur"
        }]
      },
      // 表单校验
      rules: {
        adminUserId: [{
          required: true,
          message: "平台管理员不能为空",
          trigger: "change"
        }],
        tenantId: [{
          required: true,
          message: "管理租户不能为空",
          trigger: "change"
        }]
      },
      saveLoading: false,
      saveLoading1: false,
      publicKey: '',
      searchFormData: [{
        prop: "tenantId",
        label: "租户名称",
        placeholder: "租户名称",
        type: "list",
        multiple: false,
        isSelect: false,
        filterable: true,
        span: 4,
        options: statusOptions1,
        props: {
          label: "tenantName",
          value: "id"
        },
        change: () => {}
      }, {
        prop: "username",
        label: "平台管理员用户名",
        placeholder: "平台管理员用户名",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "tenantCode",
        label: "租户编码",
        placeholder: "租户编码",
        type: "text",
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['platform-admin-tenant:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }
      // {
      //   buttonName: "批量撤销",
      //   buttonStyle: "danger",
      //   hasPermi: ['tenant:delete'],
      //   className: 'deleteBtn',
      //   buttonIcon: "Delete",
      //   exp: (item) => handleDelete(item),
      //   disabledHandle(row) {
      //     return state.multiple
      //   }
      // }
      ],
      tableHeader: [{
        prop: "username",
        label: "平台管理员"
      }, {
        prop: "nickname",
        label: "管理员昵称"
      }, {
        prop: "tenantCode",
        label: "租户编码"
      }, {
        prop: "tenantName",
        label: "租户名称"
      }, {
        prop: "createTime",
        label: "创建时间"
      }, {
        prop: "operation",
        label: "操作",
        width: "270px",
        fixed: "right",
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['platform-admin-tenant:edit']
        }, {
          name: '撤销',
          clickFun: row => handleDelete(row),
          hasPermi: ['platform-admin-tenant:delete']
        }]
      }],
      form1Data: [{
        prop: "password",
        label: "新密码",
        placeholder: "请输入新密码",
        type: "text",
        isSelect: false,
        span: 24
      }],
      formScopeData: [{
        prop: "adminUserId",
        label: "平台管理员",
        placeholder: "平台管理员",
        type: "list",
        multiple: false,
        isSelect: false,
        filterable: true,
        span: 24,
        options: statusOptions2,
        props: {
          label: "nickname",
          value: "id"
        },
        change: () => {}
      }, {
        prop: "tenantId",
        label: "租户名称",
        placeholder: "租户名称",
        type: "list",
        multiple: false,
        isSelect: false,
        filterable: true,
        span: 24,
        options: statusOptions1,
        props: {
          label: "tenantName",
          value: "id"
        },
        change: () => {}
      }, {
        prop: "remark",
        label: "备注",
        placeholder: "备注",
        type: "textarea",
        isSelect: false,
        span: 24
      }]
    });
    onMounted(() => {
      // 获取平台管理员可管理租户下拉
      listTenantOptions().then(response => {
        if (response.code == 0) {
          statusOptions1.value = response.data;
        }
      }).catch(() => {});
      // 获取平台管理员名称下拉
      listAdminOptions().then(response => {
        if (response.code == 0) {
          statusOptions2.value = response.data;
        }
      }).catch(() => {});
    });
    /** 查询租户列表 */
    const getList = function () {
      state.loading = true;
      listPermission(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.list,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      state.form = {
        adminUserId: "",
        tenantId: [],
        remark: ""
      };
    };
    const cancel = function () {
      state.open = false;
    };

    // 表单重置
    const reset = function () {
      state.form = {
        adminUserId: "",
        tenantId: [],
        remark: ""
      };
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        tenantId: '',
        tenantCode: "",
        username: ''
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = "添加租户权限";
      reset();
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = "修改租户权限";
      state.form = {
        ...row
      };
      state.openDataScope = true;
    };
    const handleDataScope = function (row) {
      getPublicKey1();
      state.open = true;
      state.form1.password = "";
      state.form1.id = row.id;
    };
    //获取公钥
    const getPublicKey1 = function () {
      getPublicKey().then(response => {
        if (response.code == 0) {
          state.publicKey = response.data;
        }
      });
    };
    const submit = function () {
      const formRef = unref(form1);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading1 = true;
          let params = {
            ...state.form1
          };
          let encrypt = new JSEncrypt();
          encrypt.setPublicKey(state.publicKey); //此处为RSA公钥
          params.password = encrypt.encrypt(params.password);
          // updatePass(params).then(response => {
          //   if (response.code == 0) {
          //     ElMessage.success("密码重置成功");
          //     state.open = false;
          //     getList();
          //   } else {
          //     ElMessage.error(response.msg);
          //   }
          //   state.saveLoading1 = false;
          // }).catch(() => {
          //   state.saveLoading1 = false;
          // });
        }
      });
    };
    /** 修改/新增租户提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          console.log(params, 'params---');
          if (state.form.id) {
            updatePermission(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addPermission(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    /** 撤销按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认撤销数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        if (row.id) {
          return deletePermission(roleIds);
        } else {
          return batchDeletePermission(roleIds);
        }
      }).then(res => {
        getList();
        ElMessage.success("撤销成功");
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.openDataScope = $event),
        size: "600px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formScopeData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.open = $event),
        size: "600px",
        title: "重置密码",
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: _ctx.saveLoading1
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form1",
          ref: form1,
          form: state.form1,
          formRules: state.rules1,
          formData: state.form1Data,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};